export type PaginationType = {
  hasNext: boolean;
  limit: number;
  page: number;
  totalRows: number;
};

export type GoalStatusFilter = "active" | "past";

export enum OrderType {
  ASCENDING = "asc",
  DESCENDING = "desc",
}
export interface ErrorResponse {
  errors: ErrorResponseObject[] | string[];
  /** A machine-readable reason some endpoints send beside `errors`. */
  code?: string;
}

export interface ErrorResponseObject {
  value: string;
  property: string;
  children: string[];
  constraints: {
    [key: string]: string;
  };
}

/**
 * One server-side failure with the field it belongs to still attached. `property` is present only
 * for DTO validation failures — a plain `{ errors: ["..."] }` from a service is not about any one
 * field. Forms route on this rather than on the message text, so rewording a server message cannot
 * silently send an error to the wrong place.
 */
export interface FieldErrorMessage {
  property?: string;
  message: string;
}
